export const ACTIVITY_OPTIONS_WITH_IDS = [
  { id: 0, label: 'Any' },
  { id: 32, label: 'EMS Comms Log' },
  { id: 72, label: 'Volunteer Sign up' },
  { id: 85, label: 'Textbank Interaction' },
  { id: -1, label: 'Form' },
  { id: 33, label: 'Web Petition/Action' },
  { id: 99, label: 'Newsletter Signup' },
  { id: 100, label: 'Yard Sign Registration' },
  { id: 101, label: 'gVIRS Manual Entry' },
  { id: 102, label: 'Rocket Manual Entry' },
];

export const ACTIVITY_STATUSES_WITH_IDS = [
  { id: 1, label: 'Scheduled' },
  { id: 2, label: 'Completed' },
  { id: 3, label: 'Cancelled' },
  { id: 4, label: 'Left message' },
  { id: 5, label: 'Unreachable' },
];
